export default __webpack_public_path__ + "static/media/mongoose.4770f038.png";